import { FileText } from "lucide-react";
import { LicitacionCard } from "./licitacion-card";
import { LicitacionTable } from "./licitacion-table";
import { EmptyState } from "@/components/ui/empty-state";
import type { Licitacion } from "@/types/licitacion";

interface LicitacionListProps {
  licitaciones: Licitacion[];
  viewMode: "cards" | "table";
  onSort?: (field: string) => void;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  onCreateClick?: () => void;
}

export function LicitacionList({ licitaciones, viewMode, onSort, sortBy, sortOrder, onCreateClick }: LicitacionListProps) {
  if (licitaciones.length === 0) {
    return (
      <EmptyState
        icon={<FileText />}
        title="No tienes licitaciones"
        description="Crea tu primera licitaci\u00f3n para empezar"
        action={onCreateClick ? { label: "Crear Licitaci\u00f3n", onClick: onCreateClick } : undefined}
      />
    );
  }

  if (viewMode === "table") {
    return (
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <LicitacionTable licitaciones={licitaciones} onSort={onSort} sortBy={sortBy} sortOrder={sortOrder} />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {licitaciones.map((lic) => (
        <LicitacionCard key={lic.id} licitacion={lic} />
      ))}
    </div>
  );
}
